import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { WebexUser } from '../coachingCenter/types'
import {
  getBranchesForCourse,
  getBranchesByInstitute,
  getWebexUserByBranch
} from './api'
import { Branch, InitialState } from './types'

const initialState: InitialState = {
  isLoading: false,
  branches: []
}

export const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    resetBranches: (state) => {
      state.branches = []
    }
  },
  extraReducers: {
    [getBranchesForCourse.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getBranchesForCourse.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<Branch>>
    ) => {
      state.isLoading = false
      state.branches = action?.payload
    },
    [getBranchesForCourse.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getBranchesByInstitute.pending.toString()]: (state) => {
      state.isLoading = true
      state.branches = []
    },
    [getBranchesByInstitute.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getBranchesByInstitute.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<Branch>>
    ) => {
      state.isLoading = false
      state.branches = action?.payload
    },
    [getWebexUserByBranch.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getWebexUserByBranch.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<WebexUser>>
    ) => {
      state.isLoading = false
      state.webexUserByBranch = action?.payload
    },
    [getWebexUserByBranch.rejected.toString()]: (state) => {
      state.isLoading = false
    }
  }
})

export default branchSlice.reducer
